// API 配置
const API_CONFIG = {
  // 基础API地址
  // BASE_URL: 'https://qcpro.xxdazz.com/prod-api',
  BASE_URL: 'https://qczs.xxdazz.com/prod-api',
  // BASE_URL: 'http://127.0.0.1:9055',
  // 本地程序版本（每次打包前手动调整）
  APP_VERSION_CODE: 1002,
  APP_VERSION_NAME: 'v2.1.1',
  
  // API端点
  ENDPOINTS: {
    LOGIN: '/card/card/api/login',
    BUTTON_PERMISSION_LIST: '/card/permission/api/list',
    BUTTON_PERMISSION_SAVE: '/card/permission/api/save',
    SHOP_LIST: '/qianchuan/info/api/shopList',
    GET_ACCESS_TOKEN_BY_CODE: '/qianchuan/info/getAccessTokenByCode',
    UPLOAD_VIDEO: 'https://ad.oceanengine.com/open_api/2/file/video/ad/',
    MATERIAL: '/qianchuan/info/api/material',
    MATERIALS: '/qianchuan/info/api/materials',
    MATERIAL_DELETE: '/qianchuan/info/api/materialDelete',
    MATERIAL_DOWNLOAD_LIST: '/qianchuan/info/api/materialDownloadList',
    MATERIAL_DOWNLOAD_FILE: '/api/material/download-file',
    MATERIAL_SHARE: '/qianchuan/info/api/materialShare',
    MATERIAL_SHARE_TIMER: '/qianchuan/info/api/materialShareTimer',
    EXPRESS_UPLOAD: '/express/record/api/upload',
    EXPRESS_LIST: '/express/record/api/list',
    EXPRESS_CHECK: '/express/record/api/check',
    EXPRESS_UPDATE_TRACKING: '/express/record/api/updateTrackingNumber',
    EXPRESS_DELETE: '/express/record/api/delete',
    QC_AUTH_INFO: '/qianchuan/info/api/authInfo',
    QC_CHECK_USERNAME_EXISTS: '/qianchuan/info/api/checkUserNameExists',
    VIDEO_MATERIAL_ID: '/qianchuan/info/api/video/materialId',
    WALLET: '/qianchuan/info/api/wallet',
    WALLET_LIST: '/qianchuan/info/api/wallet/list',
    WALLET_SOURCE: '/qianchuan/info/api/walletSource',
    WALLET_SOURCE_LIST: '/qianchuan/info/api/walletSource/list',
    WALLET_SOURCE_MANUAL_TRANSFER: '/qianchuan/info/api/walletSource/manualTransfer',
    MATERIAL_SCAN_SUMMARY: '/qianchuan/info/api/materialScanSummary',
    JOB_LIST: '/qianchuan/info/api/job/list',
    UNI_PROMOTION_JOB_LIST_BY_TARGET_ID: '/qianchuan/info/api/uniPromotionJob/listByTargetId',
    JOB_MATERIAL_THRESHOLD: '/qianchuan/info/api/job/materialThreshold',
    JOB_AUTO_MATERIAL_SWITCH: '/qianchuan/info/api/job/autoMaterialSwitch',
    JOB_MATERIAL_PATROL_LOG_EXPORT: '/qianchuan/info/api/job/materialPatrolLogs/export',
    JOB_MATERIAL_DELETE_LOG_TODAY: '/qianchuan/info/api/job/materialDeleteLogs/today',
    DEL_SHOP: '/qianchuan/info/api/delShop',
    SMART_BOOST_SWITCH: '/qianchuan/info/api/controlTask/smartBoostSwitch',
    PLATFORM_RESOURCE_LIST: '/qianchuan/info/api/platformResource/list',
    PLATFORM_RESOURCE_ADD: '/qianchuan/info/api/platformResource',
    PLATFORM_RESOURCE_DELETE: '/qianchuan/info/api/platformResource',
  },
  
  // 获取完整API URL
  getFullUrl: function(endpoint) {
    return this.BASE_URL + endpoint;
  },
  
  // 获取登录API URL
  getLoginUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.LOGIN);
  },
  getAppVersionCode: function() {
    return Number(this.APP_VERSION_CODE || 0)
  },
  getAppVersionName: function() {
    return String(this.APP_VERSION_NAME || '')
  },
  
  // 获取店铺列表API URL
  getShopListUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.SHOP_LIST);
  },
  getButtonPermissionListUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.BUTTON_PERMISSION_LIST);
  },
  saveButtonPermissionUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.BUTTON_PERMISSION_SAVE);
  },
  
  // 获取accessToken API URL
  getAccessTokenByCodeUrl: function() {
    return this.getFullUrl(this.ENDPOINTS.GET_ACCESS_TOKEN_BY_CODE);
  },

    // 添加全域投放计划下素材
  addMaterial: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL);
  },
  
    // 批量添加全域投放计划下素材
  addMaterials: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIALS);
  },
  materialDelete: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL_DELETE);
  },
  materialDownloadList: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL_DOWNLOAD_LIST);
  },
  materialDownloadFile: function() {
    return this.ENDPOINTS.MATERIAL_DOWNLOAD_FILE;
  },
  expressUpload: function() {
    return this.getFullUrl(this.ENDPOINTS.EXPRESS_UPLOAD);
  },
  expressList: function() {
    return this.getFullUrl(this.ENDPOINTS.EXPRESS_LIST);
  },
  expressCheck: function() {
    return this.getFullUrl(this.ENDPOINTS.EXPRESS_CHECK);
  },
  materialShare: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL_SHARE);
  },
  materialShareTimer: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL_SHARE_TIMER);
  },
  videoMaterialId: function() {
    return this.getFullUrl(this.ENDPOINTS.VIDEO_MATERIAL_ID);
  },
  wallet: function() {
    return this.getFullUrl(this.ENDPOINTS.WALLET);
  },
  walletList: function() {
    return this.getFullUrl(this.ENDPOINTS.WALLET_LIST);
  },
  walletSource: function() {
    return this.getFullUrl(this.ENDPOINTS.WALLET_SOURCE);
  },
  walletSourceList: function() {
    return this.getFullUrl(this.ENDPOINTS.WALLET_SOURCE_LIST);
  },
  walletSourceManualTransfer: function() {
    return this.getFullUrl(this.ENDPOINTS.WALLET_SOURCE_MANUAL_TRANSFER);
  },
  materialScanSummary: function() {
    return this.getFullUrl(this.ENDPOINTS.MATERIAL_SCAN_SUMMARY);
  },
  jobList: function() {
    return this.getFullUrl(this.ENDPOINTS.JOB_LIST);
  },
  uniPromotionJobListByTargetId: function() {
    return this.getFullUrl(this.ENDPOINTS.UNI_PROMOTION_JOB_LIST_BY_TARGET_ID);
  },
  jobMaterialThreshold: function() {
    return this.getFullUrl(this.ENDPOINTS.JOB_MATERIAL_THRESHOLD);
  },
  jobAutoMaterialSwitch: function() {
    return this.getFullUrl(this.ENDPOINTS.JOB_AUTO_MATERIAL_SWITCH);
  },
  jobMaterialPatrolLogExport: function() {
    return this.getFullUrl(this.ENDPOINTS.JOB_MATERIAL_PATROL_LOG_EXPORT);
  },
  jobMaterialDeleteLogsToday: function() {
    return this.getFullUrl(this.ENDPOINTS.JOB_MATERIAL_DELETE_LOG_TODAY);
  },
  authInfo: function() {
    return this.getFullUrl(this.ENDPOINTS.QC_AUTH_INFO);
  },
  checkUserNameExists: function() {
    return this.getFullUrl(this.ENDPOINTS.QC_CHECK_USERNAME_EXISTS);
  },
  delShop: function() {
    return this.getFullUrl(this.ENDPOINTS.DEL_SHOP);
  },
  smartBoostSwitch: function() {
    return this.getFullUrl(this.ENDPOINTS.SMART_BOOST_SWITCH);
  },
  platformResourceList: function() {
    return this.getFullUrl(this.ENDPOINTS.PLATFORM_RESOURCE_LIST);
  },
  platformResourceAdd: function() {
    return this.getFullUrl(this.ENDPOINTS.PLATFORM_RESOURCE_ADD);
  },
  platformResourceDelete: function(id) {
    return this.getFullUrl(`${this.ENDPOINTS.PLATFORM_RESOURCE_DELETE}/${id}`);
  },
  // 获取上传视频API URL
  getUploadVideoUrl: function() {
    return this.ENDPOINTS.UPLOAD_VIDEO;
  }
};

// 导出配置
export default API_CONFIG;
